import React from 'react';
import PropTypes from 'prop-types';
import {
  generateStationGroup,
  generateStationDetail
} from '../ProductionDashboardHelpers';

export default function StationsDetailThroughputTab({ productionItems, ancillaryItems, hardwareItems }) {
  return (
    <div>
      <h3>Stations Detail Throughput</h3>
      <div className="tab-content-detail">
        {productionItems && productionItems.map((station, ind) => (
          <div key={ind} className="charts-grid mt-2 pt-3 border-top">
            <h5 className="w-100 mb-3">{generateStationGroup(station.key)}</h5>
            {generateStationDetail(station.value, '', station.key)}
          </div>
        ))}

        {ancillaryItems && ancillaryItems.length > 0 && (
          <div className="charts-grid mt-2 pt-3 border-top">
            <h5 className="w-100 mb-3">Ancillaries</h5>
            {generateStationDetail(ancillaryItems.filter(b => !b.isBox))}
          </div>
        )}

        {hardwareItems && hardwareItems.length > 0 && (
          <div className="charts-grid mt-2 pt-3 border-top">
            <h5 className="w-100 mb-3">Hardwares</h5>
            {generateStationDetail(hardwareItems.filter(b => !b.isBox))}
          </div>
        )}
      </div>
    </div>
  );
}

StationsDetailThroughputTab.propTypes = {
  productionItems: PropTypes.array.isRequired,
  ancillaryItems: PropTypes.array.isRequired,
  hardwareItems: PropTypes.array.isRequired
};
